<template>
  <!-- prettier-ignore -->
  <div ref="tableRows" class="table-rows">
    <template v-for="(row, index) in data.content">
      <table-row
        :key="index"
        :icon="row.icon"
        :title="row.title"
        :selected-content-column="data.selectedContentColumn"
        :content-array="row.content"
        :is-main-type="row.isMainType"
      />
    </template>
  </div>
</template>
<script>
import TableRow from '@/components/Container/Table/TableRow'
import TableScrollMixin from '@/mixins/TableScroll'

export default {
  name: 'OvpTableRows',

  components: { TableRow },

  mixins: [TableScrollMixin],

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.tableElement = this.$refs.tableRows
    this.attachEventListeners()
  },

  beforeDestroy() {
    this.removeEventListeners()
  },
}
</script>

<style name="mobile" scoped>
.table-rows {
  display: inline-block;
  vertical-align: top;
  overflow-x: auto;
  max-width: 100%;
  position: relative;
}
</style>

<style name="desktop" scoped>
@media (--md) {
}
</style>
